module.exports = ".tip {\n  font-size: 0.7rem;\n  color: #434343; }\n  .tip pre {\n    color: #434343; }\n  .tip pre span {\n    white-space: normal; }\n  .tip .string {\n    color: green; }\n  .tip .number {\n    color: darkorange; }\n  .tip .boolean {\n    color: blue; }\n  .tip .null {\n    color: magenta; }\n  .tip .key {\n    color: red; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/variant-edit/variant-edit.component.scss
// module id = ./src/app/pages/variant-edit/variant-edit.component.scss
// module chunks = main